import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { StepItem, STEPS, Steps } from '../../../'
import { DX_CRO_BGC_NCC_LINK_GRADUATION } from '../../../../../experimentConstants'

export const determineCurrentStepNewZealand = (
  isDxOnboardingPlatformWorkflowComplete: boolean
): StepItem => {
  if (isDxOnboardingPlatformWorkflowComplete) {
    return isFeatureFlagEnabled(DX_CRO_BGC_NCC_LINK_GRADUATION)
      ? STEPS[Steps.BackgroundCheckExternalLink]
      : STEPS[Steps.Orientation]
  }
  return STEPS[Steps.StartOnBoardingWorkflow]
}
